import { Link } from 'react-router-dom';

/**
 * L'HUB «Solitari» (contratto «Solitari», S10, K3; cantiere qsolitario-orcr-45-hub): la sezione della voce 999008, UN componente solo per la Hub col gioco attivo (`HubSections`) e per la pagina `/solitario`
 * (`routes/solitario/SolitarioHome.tsx`). Una tessera per variante rilasciata; oggi una sola, «KLONDIKE». Nell'hub non c'e' altro: le classifiche e i tre ingressi sono PER VARIANTE e stanno dentro la variante
 * (`/solitario/klondike`, `HubSolitario`).
 *
 * LA TESSERA COPIA la forma di quella del selettore dei giochi (`components/games/GamePicker.tsx:81-109`, di tma-orcr, che non si tocca): `grid-cols-3 gap-3`, quadrata, `rounded-xl`, `bg-bg-secondary`, icona e
 * nome in maiuscolo 11 px bold in basso. Differenze volute: e' un `<Link>` (la zona non ha `<button>` scritti a mano, `tools/verify-solitario.ts`), e non c'e' lo stato «scelto» (nessun anello, nessun grigio:
 * tutte le tessere sono ingressi). Le icone delle varianti nuove le decide tma-ui-orcb sulle loro PR.
 *
 * ⚠️ Lo montano `HubSections` e la rotta SOLO dentro il confronto LETTERALE del flag `VITE_FEATURE_SOLITARIO_ENABLED` (che il bundler piega): questo file e il marcatore `data-sezione-solitari` non sono in produzione.
 * La serratura (`beta`, Limulo acceso) sta in `HubSections`, nel selettore e nel `RoleGate` della rotta.
 */
// Il NOME di una variante e' pubblico e uguale in ogni lingua (come i nomi delle tessere del selettore: «Klondike», «TriPeaks», «Spider»): non e' una chiave i18n.
const VARIANTI = [{ id: 'klondike', nome: 'Klondike', rotta: '/solitario/klondike', icona: '/games/solitario.svg' }] as const;

export function HubSolitari() {
  return (
    // Lo stesso contenitore scorrevole di `components/punteggio/Hub.tsx` (la radice della Hub e' `touch-action: none`, `routes/Hub.tsx`).
    <div data-sezione-solitari="true" className="flex min-h-0 flex-1 flex-col gap-4 overflow-y-auto overscroll-contain py-2 [touch-action:pan-y]">
      <ul className="grid grid-cols-3 gap-3">
        {VARIANTI.map((v) => (
          <li key={v.id}>
            <Link
              to={v.rotta}
              data-tessera-solitari={v.id}
              className="group relative flex aspect-square w-full items-end overflow-hidden rounded-xl bg-bg-secondary p-2 text-left transition-opacity active:opacity-80"
            >
              <img src={v.icona} alt="" loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
              <span className="pointer-events-none absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent px-2 py-1.5 text-[11px] font-bold uppercase tracking-wide text-white">
                {v.nome}
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
